import styled from "styled-components";
import PageWrapper from "../../common/components/PageWrapper";
import ChatHistorySearchFilter from "../component/ChatHistorySearchFilter";
import ChatHistoryTable from "../component/ChatHistoryTable";
import UserHistoryModal from "../component/UserHistoryModal";
import SessionDetailModal from "../component/SessionDetailModal";
import useChatHistoryContainer from "./ChatHistoryContainer.hook";

function ChatHistoryContainer() {
  const {
    models: {
      sessions,
      userSessions,
      messages,
      loading,
      currentPage,
      totalPages,
      totalCount,
      searchText,
      userFilter,
      startDate,
      endDate,
      selectedDatePreset,
      selectedUserId,
      isDetailModalOpen,
      isUserHistoryModalOpen,
      selectedSession,
    },
    operations: {
      formatDate,
      handleSearch,
      handleReset,
      handlePageChange,
      handleUserHistoryClick,
      handleCloseUserHistoryModal,
      handleSessionDetailClick,
      handleCloseDetailModal,
      handleDatePresetSelect,
      setSearchText,
      setUserFilter,
      setStartDate,
      setEndDate,
    },
  } = useChatHistoryContainer();

  return (
    <>
      <UserHistoryModal
        isOpen={isUserHistoryModalOpen}
        sessions={userSessions}
        userPhone={
          userSessions.length > 0 ? userSessions[0].userPhone : ""
        }
        formatDate={formatDate}
        onClose={handleCloseUserHistoryModal}
        onSessionDetailClick={handleSessionDetailClick}
      />
      <SessionDetailModal
        isOpen={isDetailModalOpen}
        session={selectedSession}
        messages={messages}
        formatDate={formatDate}
        onClose={handleCloseDetailModal}
      />
      <PageWrapper isColumnFlex>
        <PageContents>
          <HeaderSection>
            <Title>채팅 내역</Title>
          </HeaderSection>

          <ChatHistorySearchFilter
            searchText={searchText}
            userFilter={userFilter}
            startDate={startDate}
            endDate={endDate}
            totalCount={totalCount}
            selectedDatePreset={selectedDatePreset}
            onSearchTextChange={setSearchText}
            onUserFilterChange={setUserFilter}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
            onDatePresetSelect={handleDatePresetSelect}
            onSearch={handleSearch}
            onReset={handleReset}
          />

          <TableWrapper>
            <ChatHistoryTable
              sessions={sessions}
              isLoading={loading}
              page={currentPage}
              totalPages={totalPages}
              selectedUserId={selectedUserId}
              formatDate={formatDate}
              onPageChange={handlePageChange}
              onUserHistoryClick={handleUserHistoryClick}
              onSessionDetailClick={handleSessionDetailClick}
            />
          </TableWrapper>
        </PageContents>
      </PageWrapper>
    </>
  );
}

const PageContents = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  backgroundColor: theme.color.white,
  borderRadius: 10,
  padding: theme.spacing.regular,
  gap: theme.spacing.regular,
}));

const HeaderSection = styled.div(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
}));

const Title = styled.h1(({ theme }) => ({
  margin: 0,
  fontSize: 28,
  fontWeight: "bold",
  color: theme.color.black,
}));

const TableWrapper = styled.div(() => ({
  flex: 1,
  width: "100%",
  overflow: "hidden",
}));

export default ChatHistoryContainer;
